import { render } from "./DataSourcesList.vue?vue&type=template&id=094b157f"
import script from "./DataSourcesList.vue?vue&type=script&lang=js"
export * from "./DataSourcesList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__